import React, { useState, Fragment } from "react";
import { FormProvider, useForm } from "react-hook-form";
import InputFormItem from "src/components/Commons/inputElements/FormItems/InputFormItem";
import yupFormSchemas from "src/components/Commons/yup/yupFormSchemas";
import { yupResolver } from "@hookform/resolvers/yup";
import { i18n } from "src/i18n";
import * as yup from "yup";
import { Search } from "@material-ui/icons";
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from "@material-ui/core";

import IconButton from "@material-ui/core/IconButton";
import {
  AlertMsg,
  AlertTitle,
  Encrypt,
  Process_System,
  SwAlert,
} from "src/components/Systems/SystemComponent";

import { useHistory } from "react-router";
const i18nField = "common";

const useStyles = makeStyles((theme) => ({

  WidthInput: {
    width: "280px",
    [theme.breakpoints.down("md")]: {
      width: "200px"
    },
  },

}));

const SearchWeb = () => {
  const history = useHistory();
  const classes = useStyles();

  const shcema = yup.object().shape({
    search: yupFormSchemas.string(i18n(`${i18nField}.search`), {
      required: false,
    }),
  });

  const [initialValues] = useState(() => {
    return {
      search: null,
    };
  });
  const form = useForm({
    resolver: yupResolver(shcema),
    mode: "all",
    defaultValues: initialValues as any,
  });
  const searchbar = () => {
    let sSearch = form.getValues("search");
    let sUrl = "/Search?str=" + Encrypt(sSearch);
    history.push(sUrl);
  };

  return (
    <Fragment>
      <div className={classes.WidthInput}>
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(searchbar)}>
            <InputFormItem
              name="search"
              label={i18n(`${i18nField}.search`)}
              placeholder="search..."
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => {
                            searchbar();
                          }}
                    edge="end"
                  >
                    <Search/>
                  </IconButton>
                </InputAdornment>
              }
            />
          </form>
        </FormProvider>
      </div>
    </Fragment>
  );
};
export default SearchWeb;



